import React, { useCallback } from "react";
import { Tree } from "antd";
import { TreeNode } from "antd/lib/tree-select";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { setPrevState } from "../../util/common";

const { DirectoryTree } = Tree;

const TreeStructure = ({ treeData, sidebarState, setSidebarState, getSchemas, setCopyText }) => {
  const onExpand = async (expandedKeysValue, info) => {
    if (info.node.id && info.expanded) {
      const index = treeData.findIndex((obj) => obj.id === info.node.id);
      if (!treeData[index].children.length && !sidebarState.schemaLoading) await getSchemas(info.node.id);
    }

    const expandedObjects = expandedKeysValue.map((value) => value.split("-")[0]);
    setPrevState(setSidebarState, {
      expandedKeys: expandedKeysValue,
      expandedWorkspaces: [...new Set(expandedObjects)],
    });
  };

  //Copy hierarchical Text in query editor on current cursor <WARLSPACENAME>.SCHEMA.<TABLENAME/VIEWNAME>
  const copyText = useCallback((_keys, info) => setCopyText(info.hierarchicalName), [setCopyText]);

  return sidebarState.loading ? (
    <Box
      sx={{
        width: "100%",
        flex: 1,
        flexGrow: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : treeData.length ? (
    <>
      <DirectoryTree
        onExpand={onExpand}
        onDoubleClick={copyText}
        treeData={treeData}
        icon={<></>}
        expandedKeys={!sidebarState.refreshLoading && sidebarState.expandedKeys}
        defaultSelectedKeys={sidebarState.selectedKeys}
        selectedKeys={sidebarState.selectedKeys}
      />
      <Tree>
        <TreeNode />
      </Tree>
    </>
  ) : null;
};

export default React.memo(TreeStructure);
